import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { CreateDamageReportService } from '../../create-damage-report.service';
import { ProductsService } from 'app/products/products.service';
import { Product } from '@models/product';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-damage-report-step-header',
    imports: [],
    templateUrl: './damage-report-step-header.component.html',
    styleUrl: './damage-report-step-header.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DamageReportStepHeaderComponent {
    private productsService = inject(ProductsService);
    protected contract = toSignal(inject(CreateDamageReportService).selectedContract$);
    private product = computed(
        () => this.productsService.getCanonicalByInsuranceType(this.contract()?.insuranceType) as Product,
    );
    protected title = computed(
        () =>
            `${this.product()?.portalConfig.reportDamageButtonLabel ?? 'Schaden melden'} für ${this.product()?.title}`,
    );
}
